<script>
  import { format } from 'svelte-i18n';

  import { Select } from '@client/components/select';

  export let id = null;
  export let label = null;
  export let placeholder = 'label.PLACEHOLDER.SELECT';
  export let selected = [];
  export let options = [];
  export let error = null;

  export let onUpdate = () => {};

  let selectedValuesIds = [];
  let isFocused = false;
  let filterText = '';

  const onClear = ({ detail }) => {
    if (detail instanceof Array) {
      selectedValues = [];
    } else {
      selectedValues = selectedValues
        .map((item) => {
          if (item.value === detail.value) {
            return false;
          }

          return item;
        })
        .filter(Boolean);
    }

    if (onUpdate) {
      onUpdate(id, items, selectedValues);
    }
  };

  const onSelect = ({ detail = [] }) => {
    const selectedItems = detail;

    selectedValues = selectedItems.map((item) => (item.checked = true) && item).filter(Boolean);
    selectedValuesIds = selectedValues.map((item) => item.value);

    items = items.map((item) => {
      item.checked = selectedValuesIds.includes(item.value);

      return item;
    });

    if (onUpdate) {
      onUpdate(id, items, selectedValues);
    }
  };

  $: empty = !selectedValues.length && !filterText.length && !isFocused;
  $: items = [...options];
  $: selectedValues = [...selected];
</script>

<div class="field multi" class:focused={isFocused} class:empty class:error>
  <label for={id}>
    <span>{empty ? $format(placeholder) : label}</span>
    <Select
      {id}
      multiple
      placeholder={$format(placeholder)}
      bind:items
      bind:filterText
      value={selectedValues}
      on:change={onSelect}
      on:clear={onClear}
    />
  </label>
  {#if error}
    <div class="error">{error}</div>
  {/if}
</div>

<style lang="scss" src="./multi-select.scss"></style>
